var map = {
	"./buddy-1.png": "6c5e",
	"./buddy-2.png": "f518",
	"./buddy-3.png": "93e4",
	"./buddy-4.png": "ef1d",
	"./buddy-5.png": "29f3",
	"./buddy-6.png": "2b82"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3725";